import { SingleDropboxData } from './../single-dropbox/single-dropbox.component';
import { StationService } from './../../core/services/station.service';
import { StationSource } from './../../core/models/station-source';
import { Injectable } from '@angular/core';
import { chain } from 'lodash';
import { MultiDropboxData } from '..';

import { Station } from './../../core/models/station';

@Injectable({
  providedIn: 'root',
})
export class StationUtilsService {
  constructor(private stationService: StationService) { }

  // Media Monitors
  public findSourceMediaMonitors(sources: StationSource[]): StationSource {
    return sources.find((source) => this.isSourceMediaMonitors(source));
  }

  public filterStationMediaMonitors(stations: Station[]): Station[] {
    return stations.filter((station) => this.isStationMediaMonitors(station));
  }

  public findStationMediaMonitors(stations: Station[]): Station {
    return stations.find((station) => this.isStationMediaMonitors(station));
  }

  public isSourceMediaMonitors(source: StationSource): boolean {
    return source.shortname === "MM";
  }

  public isStationMediaMonitors(station: Station): boolean {
    return this.isSourceMediaMonitors(station.stationSource);
  }

  // Stream
  public filterStationSourceStream(sources: StationSource[]): StationSource[] {
    return sources.filter((source) => this.isSourceStream(source));
  }

  public findSourceMainStream(sources: StationSource[]): StationSource {
    return this.filterStationSourceStream(sources).find((source) => this.isSourceSoundPlus(source));
  }

  public findMainStreamStation(stations: Station[]): Station {
    return this.filterStationStream(stations).find((station) => this.isSourceSoundPlus(station.stationSource));
  }

  public filterStationStream(stations: Station[]): Station[] {
    return stations.filter((station) => this.isStationStream(station));
  }

  public isSourceSoundPlus(source: StationSource): boolean {
    return source.shortname === "S+";
  }

  public isSourceStream(source: StationSource): boolean {
    return source.shortname !== "MM";
  }

  public isStationStream(station: Station): boolean {
    return this.isSourceStream(station.stationSource);
  }


  //Other things
  public getFormattedStationName(station: Station): string {
    const name = station.name ? station.name : '';
    const frequency = station.frequency ? station.frequency : '';

    return `${name} ${frequency}`;
  }

  public toMultiDropboxDataGroupedByName(stations: Station[]): MultiDropboxData[] {
    return chain(stations)
      .groupBy('name')
      .map((groupedStations: Station[], stationGroupName: string) => {
        const mergedStation = this.stationService.groupStationByName(groupedStations)[0];

        return {
          id: groupedStations.map((v) => v.id),
          name: mergedStation.name,
          model: groupedStations,
          mergedStation
        };
      })
      .value();
  }

  public toSingleDropboxData(station: Station): SingleDropboxData {
    const mergedStation = this.stationService.groupStationByName([station])[0];
    return {
      id: station.id,
      name: mergedStation.name,
      model: station,
      mergedStation
    };
  }


}
